var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_dashboard",
    "data-name": "icona dashboard",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4",
    "data-name": "Tracciato 4",
    d: "M6.167,5.333h-5A1.168,1.168,0,0,1,0,4.167v-3A1.168,1.168,0,0,1,1.167,0h5A1.168,1.168,0,0,1,7.333,1.167v3A1.168,1.168,0,0,1,6.167,5.333ZM1.167,1A.167.167,0,0,0,1,1.167v3a.167.167,0,0,0,.167.167h5a.167.167,0,0,0,.167-.167v-3A.167.167,0,0,0,6.167,1Zm0,0",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5",
    "data-name": "Tracciato 5",
    d: "M6.167,222.665h-5A1.168,1.168,0,0,1,0,221.5v-7a1.168,1.168,0,0,1,1.167-1.167h5A1.168,1.168,0,0,1,7.333,214.5v7A1.168,1.168,0,0,1,6.167,222.665Zm-5-8.333A.167.167,0,0,0,1,214.5v7a.167.167,0,0,0,.167.167h5a.167.167,0,0,0,.167-.167v-7a.167.167,0,0,0-.167-.167Zm0,0",
    transform: "translate(0 -206.665)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6",
    "data-name": "Tracciato 6",
    d: "M283.5,346.665h-5a1.168,1.168,0,0,1-1.167-1.167v-3a1.168,1.168,0,0,1,1.167-1.167h5a1.168,1.168,0,0,1,1.167,1.167v3A1.168,1.168,0,0,1,283.5,346.665Zm-5-4.333a.167.167,0,0,0-.167.167v3a.167.167,0,0,0,.167.167h5a.167.167,0,0,0,.167-.167v-3a.167.167,0,0,0-.167-.167Zm0,0",
    transform: "translate(-268.665 -330.665)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7",
    "data-name": "Tracciato 7",
    d: "M283.5,9.333h-5a1.168,1.168,0,0,1-1.167-1.167v-7A1.168,1.168,0,0,1,278.5,0h5a1.168,1.168,0,0,1,1.167,1.167v7A1.168,1.168,0,0,1,283.5,9.333ZM278.5,1a.167.167,0,0,0-.167.167v7a.167.167,0,0,0,.167.167h5a.167.167,0,0,0,.167-.167v-7A.167.167,0,0,0,283.5,1Zm0,0",
    transform: "translate(-268.665 0)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.2be098e0c4e3e09d41797769388f3e60.svg";
export { ForwardRef as ReactComponent };